import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";

import * as firebase from "firebase/app";
import "firebase/firestore";

import { environment } from "../../environments/environment";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";
import { Person } from "../models/person.model";

@Injectable({
  providedIn: "root",
})
export class PersonService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "/shops";

  collRef: AngularFirestoreCollection<Person>;

  constructor(private db: AngularFirestore, private userStore: UserService) {
    this.userStore.getCurrentUser().subscribe((user: User) => {
      if (user) {
        this.userLogin = user;
        this.visibility = user.companyId
          ? user.companyId
          : environment.visibility;
      }
    });
  }

  getPersons(
    shopId: string,
    mode?: string,
    refId?: string
  ): AngularFirestoreCollection<Person> {
    return this.db.collection(this.dbPath + `/${shopId}/persons`, (ref) => {
      let query: CollectionReference | Query = ref;
      query = query.where("isDeleted", "==", false);
      query = query.where("isActive", "==", true);

      switch (mode) {
        case "customer":
          query = query.where("customerId", "==", refId);
          break;
        case "supplier":
          query = query.where("supplierId", "==", refId);
          break;
        case "employee":
          query = query.where("employeeId", "==", refId);
          break;
        case "project":
          query = query.where("projectId", "==", refId);
          break;
        default:
          break;
      }

      query = query.orderBy("updatedOn", "desc");

      return query;
    });
  }

  get(shopId: string, id: string) {
    return this.db
      .collection(this.dbPath + `/${shopId}/persons`)
      .doc(id)
      .valueChanges();
  }

  create(person: Person): any {
    person.isActive = true;
    person.isDeleted = false;
    person.createdOn = new Date();
    person.createdBy = this.userLogin.uid;
    person.updatedOn = new Date();
    person.updatedBy = this.userLogin.uid;
    person.author = this.userLogin;
    person.visibility = this.visibility;

    person.customerId = person.customerId ? person.customerId : "";
    person.customerName = person.customerName ? person.customerName : "";
    person.supplierId = person.supplierId ? person.supplierId : "";
    person.supplierName = person.supplierName ? person.supplierName : "";
    person.employeeId = person.employeeId ? person.employeeId : "";
    person.employeeName = person.employeeName ? person.employeeName : "";
    person.projectId = person.projectId ? person.projectId : "";
    person.projectName = person.projectName ? person.projectName : "";

    person.shopId = person.shopId ? person.shopId : this.userLogin.shopId;
    this.collRef = this.db.collection(
      this.dbPath + `/${person.shopId}/persons`
    );

    return this.collRef.add({ ...person }).then((docRef) => {
      person.id = docRef.id;
      return person;
    });
  }

  update(person: Person): Promise<void> {
    console.log("update person:", person);

    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    this.collRef = this.db.collection(
      this.dbPath + `/${person.shopId}/persons`
    );
    return this.collRef.doc(person.id).update({
      email: person.email ? person.email : "",
      mobile: person.mobile ? person.mobile : "",
      cardId: person.cardId ? person.cardId : "",
      fullName: person.fullName ? person.fullName : "",
      firstName: person.firstName ? person.firstName : "",
      lastName: person.lastName ? person.lastName : "",
      dob: person.dob ? person.dob : new Date(),
      dobYear: person.dobYear ? person.dobYear : 2000,
      dobMonth: person.dobMonth ? person.dobMonth : 1,
      dobDay: person.dobDay ? person.dobDay : 1,
      gender: person.gender,
      address: person.address,
      tax: person.tax,
      description: person.description,
      coverUrl: person.coverUrl ? person.coverUrl : "",
      sourceType: person.sourceType,
      content: person.content ? person.content : "",
      videoUrl: person.videoUrl ? person.videoUrl : "",
      imagesUrl: person.imagesUrl ? person.imagesUrl : [],
      tags: person.tags ? person.tags : [],
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  delete(shopId: string, id: string): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRef = this.db.collection(this.dbPath + `/${shopId}/persons`);
    return this.collRef.doc(id).update({
      isDeleted: true,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }
}
